export const cleanText = (text) => {
  return text.replaceAll("AS_", "").replaceAll(" ", "_");
};

